import React from 'react'
import _ from 'underscore'
import Select from 'react-select'
function noop() {}

var params = [
  { displayName: 'Title', apiName: 'title' },
  { displayName: 'Description', apiName: 'description' },
  { displayName: 'Event ID', apiName: 'eventID' },
  { displayName: 'Custom ID', apiName: 'customID' },
  { displayName: 'Category', apiName: 'category' },
  { displayName: 'Keyword', apiName: 'keyword' },
]

function EventsListSearch(props) {
  function handleParamSelect(param, ev) {
    ev.preventDefault()
    props.onParamSelect(param.apiName)
  }

  function parameterLi(param) {
    return (
      <li key={param.apiName}>
        <a href='#' onClick={handleParamSelect.bind(null, param)}>
          {param.displayName}
        </a>
      </li>
    )
  }

  function handleSearchChange(ev) {
    props.onSearchChange(ev.values)
  }

  var param = props.activeParameter
    ? _(params).findWhere({ apiName: props.activeParameter })
    : {
        displayName: null,
        apiName: null,
      }
  function createSelectInput() {
    var options =
      param.apiName === 'category'
        ? props.categories.map(function (cat) {
            return { value: cat.categoryName, label: cat.categoryName }
          })
        : props.keywords.map(function (keyword) {
            return { value: keyword.keyword, label: keyword.keyword }
          })
    return (
      <Select
        name='term'
        options={_(options).sortBy('label')}
        onChange={handleSearchChange}
        value={props.value || ''}
      />
    )
  }

  var searchInput =
    param.apiName === 'category' || param.apiName === 'keyword' ? (
      createSelectInput()
    ) : (
      <input
        type='text'
        className='form-control'
        name={props.name}
        placeholder='Search &hellip;'
        defaultValue={props.value}
        disabled={param.apiName === null || props.disabled}
      />
    )
  var style = {
    opacity: props.disabled ? '0.4' : 'initial',
    backgroundColor: 'initial',
    padding: 0,
  }

  return (
    <div id='event-listing-search' className='clearfix hidden-print' style={style}>
      <div>
        <div className='input-group'>
          <div className='input-group-btn'>
            <div className='btn-group'>
              <button
                disabled={props.disabled}
                type='button'
                className='btn btn-default dropdown-toggle'
                data-toggle='dropdown'
                aria-haspopup='true'
                aria-expanded='false'
              >
                {param.displayName ? (
                  param.displayName + ' '
                ) : (
                  <span>
                    <span className='hidden-xs'>Select</span> Parameter{' '}
                  </span>
                )}
                <span className='caret'></span>
              </button>

              <ul className='dropdown-menu'>
                {params.slice(0, 2).map(parameterLi)}
                <li className='divider' />
                {params.slice(2, 4).map(parameterLi)}
                {props.showCategories || props.showKeywords ? <li className='divider' /> : null}
                {props.showCategories ? parameterLi(params[4]) : null}
                {props.showKeywords ? parameterLi(params[5]) : null}
              </ul>
            </div>
          </div>

          {searchInput}
        </div>
      </div>
    </div>
  )
}

EventsListSearch.defaultProps = {
  // onSubmit: noop,
  disabled: false,
  categories: [],
  keywords: [],
  onParamSelect: noop,
  activePrameter: null,
  value: '',
  showCategories: true,
  showKeywords: true,
  name: 'events-list-search',
}

export default EventsListSearch
